package pl.mothdigital.neuronowi.common.utils

import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import org.jetbrains.compose.web.css.*
import pl.mothdigital.neuronowi.theme.*

fun Modifier.shadow(color: CSSColorValue = SiteTheme.black._900.toRgb().copy(alpha = 40)) = this.then(
    boxShadow(
        offsetX = 4.px,
        offsetY = 4.px,
        blurRadius = 8.px,
        color = color,
    )
)

/**
 * Standard padding used across all sections in the app.
 * Applies 3.cssRem vertical padding and 6% horizontal padding.
 */
fun Modifier.standardSectionPadding() = this.padding(
    topBottom = 3.cssRem,
    leftRight = 6.percent
)

/**
 * Light green background color used for section backgrounds.
 */
fun Modifier.lightGreenBackground() = this.backgroundColor(SiteTheme.green._50)

/**
 * Semi-transparent green background color used for alternating sections.
 */
fun Modifier.semiTransparentGreenBackground() = this.backgroundColor(
    SiteTheme.green._50.toRgb().copy(alpha = 128)
)

/**
 * Applies CSS aspect-ratio property to prevent Cumulative Layout Shift (CLS).
 *
 * @param ratio CSS aspect-ratio value (e.g., "16/9", "3/2", "1/1")
 */
fun Modifier.aspectRatio(ratio: String) = this.styleModifier {
    property("aspect-ratio", ratio)
}

/**
 * Enables native browser lazy loading for images.
 * Images will only load when they're about to enter the viewport.
 *
 * @param loading Loading strategy: "lazy" (default) or "eager"
 */
fun Modifier.loading(loading: String = "lazy") = this.attrsModifier {
    attr("loading", loading)
}
